<template>
  <div class="flex items-center gap-1">
    <DButton size="small" text @click="stepBackward"><SkipBack size="14" /></DButton>
    <DButton v-if="timelinePlayerStore.isPlaying" size="small" text @click="pause"><Pause size="14" /></DButton>
    <DButton v-else size="small" text @click="play"><Play size="14" /></DButton>
    <DButton size="small" text @click="pause"><Square size="14" /></DButton>
    <DButton size="small" text @click="stepForward"><SkipForward size="14" /></DButton>
    <div class="text-white">{{ timelinePlayerStore.currentTime.toFixed(3) }}s</div>
  </div>
</template>

<script setup>
import { useTimelinePlayerStore } from '@/stores/ui/timelinePlayer';
import { textureManager } from '@/threejs/textureManager';
import { DButton } from '@disguise/cloud-ui';
import { Pause, Play, SkipBack, SkipForward, Square } from 'lucide-vue-next';
const timelinePlayerStore = useTimelinePlayerStore();

const stepBackward = () => {
  timelinePlayerStore.setCurrentTime(0);
  textureManager.seekToTime(0);
};

const stepForward = () => {
  timelinePlayerStore.setCurrentTime(100);
  textureManager.seekToTime(100);
};

const play = () => {
  timelinePlayerStore.play();
  textureManager.playAllVideos();
};

const pause = () => {
  timelinePlayerStore.pause();
  textureManager.pauseAllVideos();
};
</script>
